document.addEventListener('DOMContentLoaded', function() {
  
  // # Safari on ios requires a few  hacks in order to performs file upload. one is that remote true must be disabled
  // # iOs Safari hack number 2. input elements used to upload files must be appended to the DOM
  $('#js-chat-wrapper-file').append('<input type="file" name="message[attachment]" id="js-chat-attache-file" style="visibility: hidden">');
  // # iOs Safari hack number 3. must add an hidden cache  elements in order to make ios upload work
  $('#js-chat-wrapper-file').append('<input type="hidden" name="message[attachment_cache]" id="js-chat-attache-file-cache">')


  const selectElement = document.querySelector('#js-chat-attache-file');
  if (selectElement) {

    // # iOs Safari hack number 4. use addEventListener and not selector.change

    selectElement.addEventListener('change', function (event) {
      readURL(this);
    });

    $('#js-chat-remove-btn').on('click', function (event) {
      removeURL(event);
    });

    $('#js-chat-form').on('submit', function (event) {
      $('#js-chat-wrapper-file').hide();
    });

    function removeURL (e) {
      e.preventDefault();
      $("#js-chat-attache-file").val('');
      $('#js-chat-file-name').val('');
      $('#js-chat-wrapper-file').hide();
    }

    function readURL (input) {
      if (input.files && input.files[0]) {
        let filename = $("#js-chat-attache-file").val();
        filename = filename.substring(filename.lastIndexOf('\\') + 1);
        $('#js-chat-wrapper-file').show();
        $('#js-chat-file-name').val(filename);
      }
    }
  }
});
